module.exports = __webpack_public_path__ + "img/iop.0fe15abe.svg";